import React, { Component } from 'react';
import {
  Button, ButtonGroup, Container, Col, Row, Table, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import LoanRepayment from './widgets/LoanRepayment';

export default class Mandates extends Component {
  state = {
    mandates: '',
    loading: false,
    toggle: null,
    pageload: true,
    loadmore: false,
    banks: [{
      code: '023',
      canActivateOnline: false,
      name: 'CITIBANK',
    },
    {
      code: '214',
      canActivateOnline: false,
      name: 'FIRST CITY MONUMENT BANK PLC',
    },
    {
      code: '011',
      canActivateOnline: false,
      name: 'FIRST BANK PLC',
    },
    {
      code: '035',
      canActivateOnline: false,
      name: 'WEMA BANK PLC',
    },
    {
      code: '039',
      canActivateOnline: false,
      name: 'STANBIC IBTC BANK',
    },
    {
      code: '033',
      canActivateOnline: false,
      name: 'UNITED BANK FOR AFRICA PLC',
    },
    {
      code: '101',
      canActivateOnline: true,
      name: 'PROVIDUS BANK',
    },
    {
      code: '044',
      canActivateOnline: false,
      name: 'ACCESS BANK NIGERIA',
    },
    {
      code: '050',
      canActivateOnline: false,
      name: 'ECOBANK NIGERIA PLC',
    },
    {
      code: '057',
      canActivateOnline: true,
      name: 'ZENITH BANK PLC',
    },
    {
      code: '063',
      canActivateOnline: false,
      name: 'DIAMOND BANK PLC',
    },
    {
      code: '076',
      canActivateOnline: false,
      name: 'SKYE BANK PLC',
    },
    {
      code: '082',
      canActivateOnline: true,
      name: 'KEYSTONE BANK PLC',
    },
    {
      code: '232',
      canActivateOnline: true,
      name: 'STERLING BANK PLC',
    },
    {
      code: '032',
      canActivateOnline: false,
      name: 'UNION BANK OF NIGERIA PLC',
    },
    {
      code: '030',
      canActivateOnline: false,
      name: 'HERITAGE BANK',
    },
    {
      code: '301',
      canActivateOnline: true,
      name: 'JAIZ BANK',
    },
    {
      code: '058',
      canActivateOnline: false,
      name: 'GTBANK PLC',
    },
    {
      code: '070',
      canActivateOnline: false,
      name: 'FIDELITY BANK PLC',
    },
    {
      code: '068',
      canActivateOnline: false,
      name: 'STANDARD CHARTERED BANK NIGERIA LIMITED',
    },
    {
      code: '100',
      canActivateOnline: true,
      name: 'SUNTRUST BANK NIG LTD',
    },
    {
      code: '215',
      canActivateOnline: false,
      name: 'UNITY BANK PLC',
    },
    ],
  }

  toggle = (id) => {
    this.setState({
      modal: id,
    });
  }

  canceldebit = (remitaTransRef, mandateId, requestId) => {
    if (window.confirm('Are you Sure you want to cancel this debit, the user might already be debited and you might also need to unrepay the loan on lendlot if debit reversal is successful')) {
      this.setState({ loading: true });
      axios.post('/api/canceldebit', { mandateId, remitaTransRef, requestId }, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
        axios.get('/api/getMandates', {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
          this.setState({ mandates: data, loading: false });
        }).catch((err) => {
          console.log(err.response);
        });
      }).catch(({ response }) => {
        console.error(response);
      });
    }
  }

   debit = (mandate) => {
     const amount = window.prompt('How much do you want to debit');
     const daata = {
       amount,
       mandateId: mandate.mandate.mandateId,
       fundingBankCode: mandate.mandate.payerBankCode,
       fundingAccount: mandate.mandate.payerAccount,
       // loanId: props.mandate.loan.loanId,
       clientId: mandate.mandate.clientId,
     };
     if (!amount) return;
     if (window.confirm(`Are you Sure you want to debit ${amount} from the user account, it cannot be undone`)) {
       axios.post('/api/debitMandate', daata, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
         window.alert('Debit instruction Sent to Remita Successfully. Client has been noticed through mail');
         // console.log(data);
         // this.toggle(null);
       }).catch((err) => {
         window.alert('Debit instruction Sent to Remita Failed. Client has been noticed through mail');
         console.log(err.response);
       });
     } else {
       // props.toggle(null);
     }
   };

  stopmandate = (mandateId, requestId) => {
    if (window.confirm('Are you Sure you want to cancel this mandate')) {
      this.setState({ loading: true });
      axios.post('/api/stopMandate', { mandateId, requestId }, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
        axios.get('/api/getMandates', {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => {
          this.setState({ mandates: data, loading: false });
        }).catch((err) => {
          console.log(err.response);
        });
      }).catch(({ response }) => {
        console.error(response);
      });
    }
  }

  renderMandates = () => (
    this.state.mandates
      ? this.state.mandates.map((mandate, index) => (
        mandate.mandate.clientId
          ? (
            <tr key={mandate.mandate._id}>
              <td>{index + 1}</td>
              <td>{mandate.mandate.mandateId}</td>
              <td>{mandate.mandate.payerAccount}</td>
              <td>{this.state.banks.filter(bank => bank.code == mandate.mandate.payerBankCode)[0].name}</td>
              {/* <td><Link to={`/loanDetails/${mandate.mandate.loan._id}`}>{mandate.mandate.loan.loanId}</Link></td> */}
              <td>{mandate.mandate.amount}</td>
              <td><span style={{ color: '#007bff' }} onClick={() => mandate.mandate.client && this.props.history.push(`/clientdetails/${mandate.mandate.client._id}`, { client: mandate.mandate.client })}>{mandate.mandate.clientId}</span></td>

              <td>
                {mandate.isActive ? 'Activated' : (
                  <Link
                    target="_blank"
                    to={`/mandate/${btoa(
                      `${mandate.mandate.mandateId}&${mandate.mandate.client.firstname} ${mandate.mandate.client.middlename} ${mandate.mandate.client.lastname}&${mandate.mandate.client.phoneNumber}&${mandate.mandate.client.email}&${this.state.banks.filter(bank => bank.code == mandate.mandate.payerBankCode)[0].name}&${mandate.mandate.payerAccount}&${mandate.mandate.amount}&${mandate.mandate.startDate}&${mandate.mandate.endDate}`,
                    )}`}
                  >
Bank activation form

                  </Link>
                )}

              </td>
              <td>{mandate.mandate.startDate}</td>
              <td>{mandate.mandate.endDate}</td>
              {/* <td>
                {' '}
                <Button disabled={mandate.mandate.loan.loanId == 0} size="sm" onClick={() => { this.toggle(mandate.mandateId); }} className="btnwhite">Schedule</Button>
              </td> */}
              {/* <td>
                {' '}
                <Button disabled={!mandate.isActive || this.state.loading} size="sm" onClick={() => { this.stopmandate(mandate.mandate.mandateId, mandate.mandate.requestId); }} className="btnwhite">{!this.state.loading ? 'Cancel Mandate' : 'Loading'}</Button>
              </td> */}
              <td>
                {' '}
                <Button size="sm" onClick={() => { this.debit(mandate); }} className="btnwhite">Debit Mandate</Button>
              </td>
              <td>
                {' '}
                {/* <Button disabled={mandate.mandate.loan.loanId == 0} size="sm" onClick={() => { this.toggle(mandate.requestId); }} className="btnwhite">History</Button> */}
                <Button size="sm" onClick={() => { this.toggle(mandate.requestId); }} className="btnwhite">History</Button>
              </td>
              <Modal size="lg" isOpen={this.state.modal === mandate.requestId} toggle={() => { this.toggle(null); }}>
                <ModalHeader toggle={() => { this.toggle(null); }}>
                  {mandate.paymentHistory.status}
                  {' '}
                  -
                  {' '}
                  {mandate.paymentHistory.mandateId}
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col md={12} className="my-4">
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Last Updated</th>
                            <th>Reference</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {'data' in mandate.paymentHistory && mandate.paymentHistory.data.data.paymentDetails.map((item, i) => (
                            <tr key={item.transactionRef}>
                              <td>{i + 1}</td>
                              <td>{item.status}</td>
                              <td>{item.amount}</td>
                              <td>{item.lastStatusUpdateTime}</td>
                              <td>{item.transactionRef}</td>
                              <td>
                                <Button disabled={item.statuscode == '00'} onClick={() => this.canceldebit(item.transactionRef, mandate.paymentHistory.mandateId, mandate.paymentHistory.requestId)} size="sm" color="danger">Cancel Debit Instruction</Button>

                              </td>

                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>

                </ModalBody>
                <ModalFooter>

                  <Button color="danger" className="w-100" onClick={() => { this.toggle(null); }}>Close</Button>
                </ModalFooter>
              </Modal>
              {/* <Modal size="lg" isOpen={this.state.modal === mandate.mandateId} toggle={() => { this.toggle(null); }}>
                <ModalHeader toggle={() => { this.toggle(null); }}>
                  {mandate.mandate.loan.loanId}
                  {' '}
                  -
                  {' '}
                  {mandate.mandateId}
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col md={12} className="my-4">
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Amount Due</th>
                            <th>Interest Due</th>
                            <th>Total to be Paid</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {mandate.hasOwnProperty('repayment') ? mandate.repayment.map((itemm, i) => (
                            <LoanRepayment toggle={this.toggle} debit={mandate.isActive} {...itemm} {...mandate} no={i + 1} key={`${itemm.totalDueForPeriod + itemm.period + i}`} />
                          )) : null}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>

                </ModalBody>
                <ModalFooter>

                  <Button color="danger" className="w-100" onClick={() => { this.toggle(null); }}>Close</Button>
                </ModalFooter>
              </Modal>

            */}
            </tr>
          )
          : null))
      : null
  )

  getMandates = (limit = 5, skip = 0, list = []) => axios.get(`/api/getMandates?limit=${limit}&skip=${skip}&clientId=${this.props.match.params.clientId}`, {headers:{ Authorization: localStorage.getItem('token') } }).then(({ data }) => [...list, ...data]).catch((err) => {
    console.log(err.response);
  })

  loadmore = () => {
    this.setState({ loadmore: true }, async () => {
      try {
        const count = this.state.mandates.length;
        const mandates = await this.getMandates(count + 5, count, this.state.mandates);

        this.setState({ mandates, loadmore: false });
      } catch (error) {
        console.error(error);
      }
    });
  }

  async componentDidMount() {
    const data = await this.getMandates(5, 0);

    this.setState({ mandates: data, pageload: false });
    //   axios.get('/api/getMandates').then(({ data }) => {
    //   console.log(data);
    //   this.setState({ mandates: data, pageload: false });
    // }).catch((err) => {
    //   console.log(err.response);
    // });
  }

  render() {
    if (this.state.pageload) {
      return (
        <Container>
          {' '}
          <Row>
            <Col md={3} className="mx-auto my-3 text-center">
              <FontAwesome name="spinner" size="2x" style={{ color: '#c82590' }} spin />
            </Col>
          </Row>
        </Container>
      );
    }
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <Table hover responsive>
              <thead>
                <tr>
                  <th />
                  <th>RRR</th>
                  <th>ACCOUNT NUMBER</th>
                  <th>BANK</th>
                  {/* <th>LOAN</th> */}
                  <th>AMOUNT</th>
                  <th>CLIENT</th>
                  <th>STATUS</th>
                  <th>CREATED</th>
                  <th>EXPIRY</th>
                  <th />
                  {/* <th /> */}
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.renderMandates()}
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col md={3} className="mx-auto my-3 text-center">
            {
              this.state.loadmore ? 'Please wait....' : <Button onClick={this.loadmore} outline block color="warning">Load More</Button>
            }
          </Col>
        </Row>
      </Container>
    );
  }
}
